export const convertBase64toBlob = (base64) => fetch(base64).then((res) => res.blob())
